// REAL ESTATE REGISTRY
export const GET_REAL_ESTATE_REGISTRIES = '/real_estate_registry/query';
export const GET_REAL_ESTATE_REGISTRY = '/real_estate_registry/';
export const POST_REAL_ESTATE_REGISTRY = '/real_estate_registry/';
export const PUT_REAL_ESTATE_REGISTRY = '/real_estate_registry/';
export const DELETE_REAL_ESTATE_REGISTRY = '/real_estate_registry/';
export const CHECK_REAL_ESTATE_REGISTRY_EXISTS = '/real_estate_registry/query';
